import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { flow, map, isEmpty } from 'lodash';
import {Field, reduxForm} from 'redux-form';
import { IAuthState } from '../../../../../../services/auth/models';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import {isRequired, isEmail} from '../../../../../../util/validators';
import {Link} from 'react-router-dom';
import {translatePasswordError} from '../../../../../../util/helpers';

interface IResetPasswordFormProps {
  actions: {
    push(route: string);
  };
  auth: IAuthState;
  buttonText: string;
  handleSubmit: () => void;
}

class ResetPasswordForm extends React.Component<IResetPasswordFormProps> {
  public render() {
    const { handleSubmit, buttonText, auth } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Votre adresse électronique
          </Col>
          <Col sm={5}>
            <Field
              name="email"
              type="email"
              component={FieldFormControl}
              validate={[isRequired, isEmail]}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Votre mot de passe
          </Col>
          <Col sm={5}>
            <Field
              name="password"
              type="password"
              validate={[isRequired]}
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Confirmez votre mot de passe
          </Col>
          <Col sm={5}>
            <Field
              type="password"
              name="passwordConfirmation"
              validate={[isRequired]}
              component={FieldFormControl}
            />
          </Col>
        </FormGroup>
        <div className="alert alert-warning">
          Votre mot de passe doit contenir au minimum 10 caractères dont une minuscule, une majuscule,
          un caractère spécial et un chiffre
        </div>
          <p>En créant votre espace personnel, vous acceptez les
             <Link to="/general-conditions"> conditions générales d'utilisation</Link> du site.</p>
        {auth && auth.error && ! isEmpty(auth.error.reset) && (
          <div className="alert alert-danger" style={{marginTop: '10px'}}>
            {map(auth.error.reset, (error, key) => {
              return <p key={key}>{translatePasswordError(error.detail)}</p>;
            })}
          </div>
        )}
        <div className="btn-bar section">
          <Button
            type="submit"
            className="btn btn-secondary red pull-right"
          >
            {buttonText ? buttonText : 'Réinitialiser votre mot de passe'}
          </Button>
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Les mots de passe ne sont pas identiques, merci de les entrer à nouveau.';
  }
  return errors;
};

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    validate,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ResetPasswordForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ResetPassword/components/ResetPasswordForm/index.tsx